import styled from 'styled-components'
import closeSvg from 'assets/images/close-icon.svg'
import { Color } from 'root-constants'

type TWrapperProps = {
  isVisible: boolean
}

export const StyledCheckout = {
  Wrapper: styled.div<TWrapperProps>`
    display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
    max-width: 360px;
    margin: 0 auto;
    padding: 50px 30px 60px;
    text-align: center;
    position: relative;
    z-index: 2;
  `,
  Title: styled.h2`
    margin-bottom: 16px;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
  `,
  DescriptionContainer: styled.div`
    display: flex;
    justify-content: space-between;
    font-weight: 400;
    font-size: 16px;
    line-height: 43px;
    margin-bottom: 8px;
  `,
  PersonalizedPlan: styled.span`
    text-align: left;
  `,
  PlanPrice: styled.span`
    font-weight: 700;
  `,
  Discount: styled.span`
    font-weight: 700;
    color: #e22a61;
  `,
  TotalAmountContainer: styled.div`
    display: flex;
    justify-content: space-between;
    padding-top: 8px;
    border-top: 1px solid #eaeaec;
    font-weight: 700;
    font-size: 16px;
    line-height: 43px;
  `,
  DiscountDescription: styled.p`
    font-weight: 600;
    font-size: 12px;
    line-height: 8px;
    color: #e22a61;
    text-align: right;
  `,
  PaymentContainer: styled.div`
    margin-top: 16px;
  `,
  ButtonContainer: styled.div`
    margin-bottom: 28px;
  `,
  Image: styled.img`
    margin: 32px auto 23px;
    max-width: 256px;
  `,
  Text: styled.p`
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: ${Color.WHITE};
    opacity: 0.7;
  `,
  CloseButton: styled.button`
    padding: 0;
    display: block;
    position: absolute;
    z-index: 3;
    top: 56px;
    right: 15px;
    width: 24px;
    height: 24px;
    border: none;
    outline: none;
    cursor: pointer;
    background-size: 20px 20px;
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url(${closeSvg});
  `,
  ThreeDSecureIframe: styled.iframe`
    height: calc(var(--full-height, 100vh) - 50px) !important;
    padding: 15px;
  `,
}
